<template>
  <div class="result">
    <div class="info-row">
      <b>团队名称：</b>
      <el-select
        v-model="teamId"
        size="medium"
        placeholder="请选择团队"
        @change="getResult"
      >
        <el-option
          v-for="item in list"
          :key="item.teamId"
          :label="item.name"
          :value="item.teamId"
        >
        </el-option>
      </el-select>
      <div class="captain">
        队长姓名：
        <span>{{ teamResult.captainName }}</span>
      </div>
    </div>

    <table
      width="100%"
      border="1"
      cellspacing="0"
      cellpadding="20"
      align="center"
      class="table"
    >
      <tr class="head">
        <td colspan="2">自身（商家侧）</td>
        <td colspan="2">定位（交集）</td>
        <td colspan="2">用户（需求侧）</td>
      </tr>
      <tr>
        <td class="label" width="10%">产品属性</td>
        <td width="23%">{{ teamResult.cpsx }}</td>
        <td class="label" width="10%">功能价值</td>
        <td width="23%">{{ teamResult.gnjz }}</td>
        <td class="label" width="10%">用户需求</td>
        <td width="23%">{{ teamResult.yhxq }}</td>
      </tr>
      <tr>
        <td class="label" width="10%">IP自身属性（外在）</td>
        <td width="23%">{{ teamResult.ipzssx }}</td>
        <td class="label" width="10%">势能关系</td>
        <td width="23%">{{ teamResult.sngx }}</td>
        <td class="label" width="10%">用户群体画像</td>
        <td width="23%">{{ teamResult.yhqthx }}</td>
      </tr>
      <tr>
        <td class="label" width="10%">IP人格属性（内在）</td>
        <td width="23%">{{ teamResult.iprgsx }}</td>
        <td class="label" width="10%">情感性质</td>
        <td width="23%">{{ teamResult.qgxz }}</td>
        <td class="label" width="10%">审美喜好</td>
        <td width="23%">{{ teamResult.smxh }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { teamList } from "@/api/team";
import { result } from "@/api/projectPractice/accountLocation";

export default {
  data() {
    return {
      teamId: null,
      list: [],
      teamResult: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 团队列表
    getList() {
      teamList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          if (this.list) this.teamId = this.list[0].teamId;

          this.getResult();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 团队结果
    getResult() {
      this.$loading.show();
      result(this.teamId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.teamResult = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.result {
  .info-row {
    margin-bottom: 10px;
    text-align: left;
    line-height: 36px;
    overflow: hidden;
    .captain {
      float: right;
      font-weight: bold;
      span {
        color: teal;
      }
    }
  }
  .table {
    border-color: #f2f6fc;
    .head {
      background: #f5f5f5;
      font-weight: bold;
    }
    .label {
      font-weight: bold;
    }
  }
}
</style>